import { LICENSING } from "@/data/site";
import { COMPANY } from "@/config/company";
import { LICENSING_DISCLOSURE_IDENTITY_ES, LICENSING_DISCLOSURE_PARAGRAPHS_ES, NMLS_CONSUMER_ACCESS_LABEL } from "@/lib/legal-disclosure";
import { EqualHousingLogo } from "@/components/site/EqualHousingLogo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

type Props = {
  className?: string;
  headingClassName?: string;
  collapsibleDetails?: boolean;
  locale?: "en" | "es";
};

/** Canonical licensing & disclosures block. Use anywhere licensing is stated. */
export function LicensingDisclosure({ className = "", headingClassName = "", collapsibleDetails = false, locale = "en" }: Props) {
  const identity = locale === "es" ? LICENSING_DISCLOSURE_IDENTITY_ES : [LICENSING.entity, LICENSING.branch, LICENSING.licenses, LICENSING.phone, LICENSING.equalHousing];
  const paragraphs = locale === "es" ? LICENSING_DISCLOSURE_PARAGRAPHS_ES : LICENSING.paragraphs;
  const details = (
    <>
      {paragraphs.map((p) => (
        <p key={p.slice(0, 24)} className="mt-3">
          {p}
        </p>
      ))}
    </>
  );
  return (
    <div className={className}>
      <div className={`font-semibold ${headingClassName}`}>{locale === "es" ? "Licencias y divulgaciones" : LICENSING.heading}</div>
      {identity.slice(0, 4).map((line, index) => <p key={line} className={index === 0 ? "mt-1" : undefined}>{line}</p>)}
      <div className="mt-2 flex items-center gap-2">
        <EqualHousingLogo size={28} showText={false} />
        <span>{identity[4]}</span>
      </div>
      {collapsibleDetails ? (
        <Accordion type="single" collapsible className="mt-3 border-y border-current/20">
          <AccordionItem value="full-disclosure" className="border-0">
            <AccordionTrigger className="py-3 font-semibold hover:no-underline">
              {locale === "es" ? "Leer la divulgación legal y de licencias completa" : "Read full licensing and legal disclosure"}
            </AccordionTrigger>
            <AccordionContent className="pb-4">{details}</AccordionContent>
          </AccordionItem>
        </Accordion>
      ) : details}
      <p className="mt-3">
        NMLS Consumer Access:{" "}
        <a
          href={COMPANY.nmlsConsumerAccessUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold underline underline-offset-2"
        >
          {locale === "es" ? `Verifique Simply Approved Mortgages LLC, NMLS #${COMPANY.companyNmlsId}` : NMLS_CONSUMER_ACCESS_LABEL}
        </a>
        .
      </p>
    </div>
  );
}
